export default __webpack_public_path__ + "static/media/1.1ee5d356.jpg";